import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

export interface AuthData {
  accessToken: string | null;
  expires: number | null;
}

export interface AuthState extends AuthData {
  isLoggedIn: boolean;
}

const initialState: AuthState = {
  accessToken: localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null,
  expires: +localStorage.getItem('expires')! ? +localStorage.getItem('expires')! : null,
  isLoggedIn: !!localStorage.getItem('accessToken')
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<AuthData>) => {
      const { accessToken, expires } = action.payload;
      state.accessToken = accessToken;
      state.expires = expires;
      state.isLoggedIn = !!accessToken;
    },
    unsetCredentials: state => {
      state.accessToken = null;
      state.expires = null;
      state.isLoggedIn = false;
    }
  }
});

export const { setCredentials, unsetCredentials } = authSlice.actions;

export default authSlice.reducer;
// Selectors
export const selectCurrentLoginStatus = (state: RootState) => state.auth.isLoggedIn;
export const selectCurrentAccessToken = (state: RootState) => state.auth.accessToken;
export const selectCurrentAuthState = (state: RootState) => state.auth;
